__turbopack_context__.v({
  "card": "cardTooltip-module-scss-module__2Il3oa__card",
  "cardBack": "cardTooltip-module-scss-module__2Il3oa__cardBack",
  "cardTooltip": "cardTooltip-module-scss-module__2Il3oa__cardTooltip",
  "loader": "cardTooltip-module-scss-module__2Il3oa__loader",
});
